import { createReducer } from 'utils/reduxCreators';
import { fetchSuspensionRules } from 'services/suspensionRules';
import { updateAppLoading } from './meta';

export const RECEIVED_SUSPENSION_RULES =
  'suspensionRules/RECEIVED_SUSPENSION_RULES';

const initialState = {
  rules: [],
};

export default createReducer(initialState, {
  [RECEIVED_SUSPENSION_RULES]: (state, { payload }) => {
    return {
      ...state,
      rules: payload,
    };
  },
});

export const getSuspensionRules = () => async (dispatch) => {
  dispatch(updateAppLoading(true));
  try {
    const rules = await fetchSuspensionRules();
    dispatch(updateAppLoading(false));
    dispatch({ type: RECEIVED_SUSPENSION_RULES, payload: rules });
  } catch (e) {
    dispatch(updateAppLoading(false));
    // Important to throw it back as it gets caught by the middleware.
    throw e;
  }
};
